<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12">
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text" v-if="loading.getdata">
              <v-col cols="12" md="12" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
            </v-row>
            <v-row class="black--text" v-if="!loading.getdata && datalist.length > 0">
              <v-col cols="12" md="9">
                <div class="d-flex">
                  <div class="d-inline mr-5">
                    <v-img
                      :lazy-src="require('../../assets/default.jpg')"
                      max-height="70"
                      max-width="70"
                      :src="datalist[0].urlpic ? datalist[0].urlpic : ''">
                    </v-img>
                  </div>
                  <div class="d-inline">
                    <h2 class="text-md-h4 mb-2 font-weight-bold">
                      {{ datalist[0].user_firstname }} {{ datalist[0].user_lastname }}
                    </h2>
                    <v-chip
                      class="mr-1 mb-1"
                      color="deep-orange"
                      small
                      dark>
                      <v-icon left small>
                        mdi-cash-multiple
                      </v-icon>
                      {{ datalist[0].js_pref_salary ? datalist[0].js_pref_salary : 1 | rupiahformat }}
                    </v-chip>
                    <v-chip
                      class="mr-1 mb-1"
                      color="primary"
                      small
                      dark>
                      <v-icon left small>
                        mdi-map-marker
                      </v-icon>
                      {{ datalist[0].js_pref_location ? datalist[0].js_pref_location : 'Location'}}
                    </v-chip>
                    <v-chip
                      class="mr-1 mb-1"
                      color="green"
                      small
                      dark>
                      <v-icon left small>
                        mdi-account-hard-hat
                      </v-icon>
                      {{ datalist[0].js_pref_special ? datalist[0].js_pref_special : 'Specialization'}}
                    </v-chip>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="3" :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-right'">
                <v-btn
                  class="mr-2 mb-2"
                  depressed
                  color="error"
                  @click="updateProfile(datalist[0])">
                  <v-icon small left>
                    mdi-pencil
                  </v-icon>
                  Update Profile
                </v-btn>
              </v-col>
              <v-col cols="12" md="12">
                <v-tabs
                  v-model="tabdata"
                  show-arrows>
                  <v-tabs-slider :color="maincolor"></v-tabs-slider>
                  <v-tab href="#recomendation" active-class="main-style-slide">
                    Recomendation
                  </v-tab>
                  <v-tab href="#savedjob" active-class="main-style-slide">
                    My Saved Job
                  </v-tab>
                  <v-tab href="#applications" active-class="main-style-slide">
                    Job Application
                  </v-tab>
                </v-tabs>
                <v-divider></v-divider>
                <v-tabs-items :touchless="true" v-model="tabdata">
                  <v-tab-item value="recomendation">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="paramjob.type"
                              :items="listtype"
                              label="Job Type"
                              name="jobtype"
                              prepend-inner-icon="mdi-account-hard-hat">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              prepend-inner-icon="search"
                              v-model="paramjob.keyword"
                              label="Job title, company name"
                              name="keyword">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-btn
                              class="mt-1 white--text"
                              type="submit"
                              large
                              :color="maincolor"
                              block
                              @click="getRecomFilter">
                              <v-icon left>search</v-icon> Search
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-row v-if="jobreclist.length > 0">
                              <v-col
                                class="d-flex" style="flex-direction:column"
                                cols="12"
                                md="4"
                                v-for="(job, i) in jobreclist"
                                :key="i">
                                <job :job="job"></job>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="12">
                            <infinite-loading :identifier="infiniteId" @infinite="getRecJob">
                              <div slot="spinner">Loading...</div>
                              <div slot="no-more"></div>
                              <div slot="no-results"></div>
                            </infinite-loading>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="savedjob">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="paramsave.type"
                              :items="listtype"
                              label="Job Type"
                              name="jobtype"
                              prepend-inner-icon="mdi-account-hard-hat">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              prepend-inner-icon="search"
                              v-model="paramsave.keyword"
                              label="Job title, keyword"
                              name="keyword">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-btn
                              class="mt-1 white--text"
                              type="submit"
                              large
                              :color="maincolor"
                              block
                              @click="getSaveFilter">
                              <v-icon left>search</v-icon> Search
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-row v-if="jobsavelist.length > 0">
                              <v-col
                                class="d-flex" style="flex-direction:column"
                                cols="12"
                                md="4"
                                v-for="(job, i) in jobsavelist"
                                :key="i">
                                <job :job="job"></job>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="12">
                            <infinite-loading :identifier="infiniteSaveId" @infinite="getSaveJob">
                              <div slot="spinner">Loading...</div>
                              <div slot="no-more"></div>
                              <div slot="no-results"></div>
                            </infinite-loading>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="applications">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="paramapp.type"
                              :items="listtype"
                              label="Job Type"
                              name="jobtype"
                              prepend-inner-icon="mdi-account-hard-hat">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              prepend-inner-icon="search"
                              v-model="paramapp.keyword"
                              label="Job title, keyword"
                              name="keyword">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-btn
                              class="mt-1 white--text"
                              type="submit"
                              large
                              :color="maincolor"
                              block
                              @click="getAppFilter">
                              <v-icon left>search</v-icon> Search
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-row v-if="jobapplist.length > 0">
                              <v-col
                                class="d-flex" style="flex-direction:column"
                                cols="12"
                                md="6"
                                v-for="(job, i) in jobapplist"
                                :key="i">
                                <jobjobseeker :job="job"></jobjobseeker>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="12">
                            <infinite-loading :identifier="infiniteAppId" @infinite="getAppJob">
                              <div slot="spinner">Loading...</div>
                              <div slot="no-more"></div>
                              <div slot="no-results"></div>
                            </infinite-loading>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-row class="black--text" v-if="!loading.getdata && datalist.length <= 0">
              <v-col cols="12" md="12">
                <v-alert type="warning">
                  Data not available, please try refreshing the data with the button below!
                </v-alert>
                <div class="text-center">
                  <v-btn
                    fab
                    depressed
                    color="primary"
                    @click="getProfile">
                    <v-icon dark large>
                      mdi-refresh
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.profile"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.profile">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Update Profile {{ dmodaldata.profile.user_lastname }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('profile')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="10">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitUpdateProfile"
                    ref="formupdprofile"
                    v-model="formadd.company"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="8">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              v-model="dmodaldata.profile.js_pref_special"
                              :items="listspecial"
                              :rules="[rules.required]"
                              label="Specialization">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              v-model="dmodaldata.profile.js_pref_location"
                              :items="listlocation"
                              :rules="[rules.required]"
                              label="Location">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.profile.js_pref_salary"
                              :rules="[rules.required]"
                              label="Expected salary *"
                              name="js_pref_salary"
                              type="number">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.profile.js_phone"
                              :rules="[rules.required]"
                              label="Phone *"
                              name="js_phone">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.js_address"
                              :rules="[rules.required]"
                              label="Address *"
                              name="js_address">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <label>About me</label>
                            <vue-editor
                              v-model="dmodaldata.profile.js_desc"
                              placeholder="Description"
                              :rules="[rules.required]">
                            </vue-editor>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-autocomplete
                              v-model="dmodaldata.profile.js_sex"
                              :items="listgender"
                              :rules="[rules.required]"
                              label="Gender *"
                              name="js_sex">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-menu
                              v-model="datepick.birthdate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="dmodaldata.profile.js_birthdate"
                                  label="Birthday (yyyy-mm-dd) *"
                                  readonly
                                  v-on="on"
                                  :rules="[rules.required]">
                                </v-text-field>
                              </template>
                              <v-date-picker
                                ref="birthday"
                                :max="datepick.date"
                                name="js_birthdate"
                                v-model="dmodaldata.profile.js_birthdate"
                                @input="datepick.birthdate = false">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.js_birthplace"
                              :rules="[rules.required]"
                              label="Birthplace *"
                              name="js_birthplace">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.updcomp"
                          :disabled="loading.updcomp || !formadd.company"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Update profile
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import Job from '../../components/Job.vue';
import Jobjobseeker from '../../components/Jobjobseeker.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';
import { priceFromat } from '@/plugins/utils';

export default {
  name: 'DashboardJs',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertpic: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      updcomp: false,
      avatar: false,
    },
    tabdata: 'profile',
    publickey: '123',
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    jobreclist: [],
    jobsavelist: [],
    jobapplist: [],
    listtype: process.env.VUE_APP_TYPEJOB.split(','),
    listgender: process.env.VUE_APP_GENDER.split(','),
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    listspecial: ['IT-Software', 'IT-Hardware', 'Hotel', 'Tourism', 'Public Relations', 'Banking', 'Accounting'],
    paramjob: {
      special: '',
      type: '',
      location: '',
      keyword: '',
      gaji: [0, 9],
      limit: 20,
      offset: 0,
    },
    paramsave: {
      type: '',
      keyword: '',
      limit: 20,
      offset: 0,
    },
    paramapp: {
      type: '',
      keyword: '',
      limit: 20,
      offset: 0,
    },
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      company: false,
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      profile: false,
    },
    dmodaldata: {
      profile: null,
    },
    myCroppa: {},
    infiniteId: +new Date(),
    infiniteSaveId: +new Date(),
    infiniteAppId: +new Date(),
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      birthdate: false,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getProfile();
    // init type job
    if (this.userrole === 'student') {
      this.paramjob.type = this.listtype[2];
    } else {
      this.paramjob.type = this.listtype[0];
    }
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    'datepick.birthdate'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  methods: {
    getAppFilter() {
      this.paramapp.offset = 0;
      this.jobapplist = [];
      this.infiniteAppId += 1;
    },
    getAppJob($state) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jobs/apply-js',
            {
              params: this.paramapp,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramapp.offset += this.paramapp.limit;
                  resdata.data.forEach((element) => {
                    element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                    this.jobapplist.push(element);
                  });
                  // this.jobapplist.push(...resdata.data);
                  if (this.jobapplist.length < this.paramapp.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    getSaveFilter() {
      this.paramsave.offset = 0;
      this.jobsavelist = [];
      this.infiniteSaveId += 1;
    },
    getSaveJob($state) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jobs/save',
            {
              params: this.paramsave,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramsave.offset += this.paramsave.limit;
                  resdata.data.forEach((element) => {
                    element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                    this.jobsavelist.push(element);
                  });
                  // this.jobsavelist.push(...resdata.data);
                  if (this.jobsavelist.length < this.paramsave.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    getRecomFilter() {
      this.paramjob.offset = 0;
      this.jobreclist = [];
      this.infiniteId += 1;
    },
    getRecJob($state) {
      this.axios
        .get(
          this.api + '/public/jobs',
          {
            params: this.paramjob,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramjob.offset += this.paramjob.limit;
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                  this.jobreclist.push(element);
                });
                // this.jobreclist.push(...resdata.data);
                if (this.jobreclist.length < this.paramjob.offset) {
                  if ($state !== false) {
                    $state.complete();
                  }
                } else {
                  if ($state !== false) {
                    $state.loaded();
                  }
                }
              } else {
                if ($state !== false) {
                  $state.complete();
                }
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getProfile() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/user/profile',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.datalist = resdata.data;
                if (resdata.data[0].js_picture) {
                  this.datalist[0].urlpic = this.api + '/upload/avatar/' + resdata.data[0].js_picture;
                } else {
                  this.datalist[0].urlpic = '';
                }
                // init data
                this.paramjob.special = this.datalist[0].js_pref_special;
                this.paramjob.location = this.datalist[0].js_pref_location;
                this.paramjob.gaji[1] = (this.datalist[0].js_pref_salary / 1000000);
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    closeDmodal(type) {
      if (type === 'profile') {
        this.dmodal.profile = false;
      } else {
        this.dmodal.profile = false;
      }
    },
    updateProfile(item) {
      this.dmodal.profile = true;
      this.dmodaldata.profile = JSON.parse(JSON.stringify(item));
    },
    submitUpdateProfile() {
      // console.log(this.dmodaldata.profile);
      this.alertupdate.show = false;
      if (this.$refs.formupdprofile.validate()) {
        if (this.tokenscr) {
          this.loading.updcomp = true;
          this.axios
            .put(
              this.api + '/api/user/js-profile',
              qs.stringify(
                this.dmodaldata.profile,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = this.dmodaldata.profile.user_lastname + ' has been changed successfully!';
                  this.getProfile();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.updcomp = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.updcomp = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
    InfiniteLoading,
    Job,
    Jobjobseeker,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
